import './src/main.css'
import BorderBox3 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox3.name, BorderBox3)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox3/index.js